import React, { ReactNode, useState } from 'react';
import {
  billingHeaderContext,
  BillingHeaderContextTo,
} from './billing-header-context';

type Props = {
  children: ReactNode;
};

export function BillingHeaderProvider(props: Readonly<Props>) {
  const { children } = props;
  const [billingHeader, setBillingHeader] = useState<
    BillingHeaderContextTo | undefined
  >(undefined);
  const [billingQuote, setBillingQuote] = useState<
    BillingHeaderContextTo | undefined
  >(undefined);

  const modifyBillingHeader = (address: BillingHeaderContextTo) => {
    setBillingHeader(address);
    localStorage.setItem('billingAddress', JSON.stringify(address));
  };

  const modifyBillingQuote = (address: BillingHeaderContextTo | undefined) => {
    setBillingQuote(address);
  };

  const { Provider } = billingHeaderContext;

  return (
    <Provider
      value={{
        billingHeader,
        billingQuote,
        modifyBillingHeader,
        modifyBillingQuote,
      }}
    >
      {children}
    </Provider>
  );
}
